<div class="d-flex flex-column">
    <div class="d-flex flex-column">
        @if (slides[currentSlide].title) {
            <h4>{{ slides[currentSlide].title }}</h4>
        }
        <div class="d-flex align-items-center justify-content-between">
            <ws-ace-icon glyph="chevron-left"
                         size="2"
                         class="clickable pe-3"
                         (click)="prevSlide()">
            </ws-ace-icon>
            <div class="flex-grow-1">
                @if (slides[currentSlide].imageUrl) {
                    <img [src]="slides[currentSlide].imageUrl"
                         alt="slide"
                         class="carousel-image w-100">
                } @else if (slides[currentSlide].template) {
                    <ng-container *ngTemplateOutlet="slides[currentSlide].template">
                    </ng-container>
                }
            </div>
            <ws-ace-icon glyph="chevron-right"
                         size="2"
                         class="clickable ps-3"
                         (click)="nextSlide()">
            </ws-ace-icon>
        </div>
        @if (slides[currentSlide].description) {
            <p>{{ slides[currentSlide].description }}</p>
        }
    </div>
    <div class="d-flex justify-content-center w-100 py-3">
        @for (slide of slides; track slide; let i = $index) {
            <div class="slide-progress clickable mx-1"
                 [ngClass]="{'active': i === currentSlide}"
                 (click)="goToSlide(i)">
            </div>
        }
    </div>
    @if (!disableControls) {
        <div>
            <ws-ace-button (click)="prevSlide()"
                           content="Previous"
                           buttonStyle="secondary"
                           state="action">
                Prev
            </ws-ace-button>
            <ws-ace-button (click)="nextSlide()"
                           content="Previous"
                           buttonStyle="primary"
                           state="action">
                Next
            </ws-ace-button>
        </div>
    }
</div>
